module.exports = __webpack_public_path__ + "img/cooperate_24.af85ad9f.png";